import axios from 'axios'
import {jsonHeader, wwwFormHeader} from '@/helpers/axiosHeaders'
import Vue from 'vue'
import qs from "qs";

const state = {
    items: [],
}
const getters = {}
const mutations = {
    setItems(state, data) {
        state.items = [];
        if (typeof data === 'object' && data.items !== undefined) {
            for (let itemIndex in data.items) {
                let item = data.items[itemIndex];
                state.items.push(item);
            }
        }
    },
}
const actions = {
    getItems(context, data) {
        if (!state.isLoad) {
            context.commit('setItems', {});
            axios.get(process.env.VUE_APP_API_PATH+'/moderator/queries/', {
                headers: {'Content-Type': 'application/json;charset=utf-8','Authorization': localStorage.getItem('token') !== 'false' && localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined ? localStorage.getItem('token') : false},
                withCredentials: true,
            }).then(response => {
                context.commit('setLoad', false);
                if (typeof response.data === 'object' && +response.data.error === 0) {
                    context.commit('setItems', response.data.result);
                } else {
                    if( +response.data.error===401){
                        context.dispatch('auth/logout',{},{root:true})
                    }
                }
            }).catch(function (error) {
                context.commit('setLoad', false);
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
            });
        }
    },
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}